export const generateLocalId = (tableId?: string, viewId?: string) => `${tableId}-${viewId}`;
